import {
    inboxBriefingMorningCommandText,
    inboxBriefingEveningCommandText,
} from './getInboxBriefing.locstring.json';
import { isEveningBriefing } from './currentTimeCheckUtils';
import loc, { type LocalizedString } from 'owa-localize';

/**
 * Helper function to determine which inbox briefing command to use based on current time
 */
export function getInboxBriefingCommandText(): LocalizedString {
    // Default to morning briefing for any other time
    return isEveningBriefing()
        ? loc(inboxBriefingEveningCommandText)
        : loc(inboxBriefingMorningCommandText);
}
